/* eslint-disable */
// AUTO-GENERATED by scripts/generate-antd-compat-icons.mjs — do not edit by hand.
// Regenerate after changing icon-map.txt: `node scripts/generate-antd-compat-icons.mjs`
import { MoreOutlined as AntdMoreOutlined } from '@ant-design/icons'
import { EllipsisVertical } from 'lucide-react'

import { createIconDispatcher } from '../dispatch'

export default /*#__PURE__*/ createIconDispatcher(
  'more',
  AntdMoreOutlined,
  EllipsisVertical
)
